module.exports = __webpack_public_path__ + "img/bird_3.155ac3d8.png";